.notFound {
	display: flex;
	flex-direction: column;
	gap: var(--spacing-8);
	align-items: center;
	justify-content: center;
	min-block-size: 100dvh;
	padding: var(--spacing-6);

	.logo {
		color: var(--colour-text-primary);
	}

	.code {
		font-size: var(--font-size-3xl);
		font-weight: var(--font-weight-bold);
		color: var(--colour-brand-text);
		letter-spacing: var(--letter-spacing-wide);
	}
}
